import FirstViewControl from './FirstViewControl'
import ThirdViewControl from './ThirdViewControl'

export {
  FirstViewControl,
  ThirdViewControl,
}